import React from "react";
import { NavLink, Redirect, Switch } from "react-router-dom";
import cardTypes from "../../constants/cardTypes";
import { PrivateRoute } from "../../components/privateRoute";
import styles from './cards.module.scss';
import CardList from './CarCards/cards';
import UserCardList from './UserCards/user_cards';
import { useLocalization } from "../../hooks/useLocalization";
import EditCard from "./CarCards/edit_card";
import { AccessLevel, AppModules } from "../../constants/appAccess";
import EditUserCard from "./UserCards/edit_user_card";

const CardsPage = () => {
    const {t} = useLocalization();
    return (
        <div>
                <div className={styles.cards_page_header_container}>
                    <div>
                        <ul>
                            <li>
                                <NavLink to="/cards/cars" activeClassName={styles.is_active}>{t("CardsPagesNames.Cars")}</NavLink>
                            </li>
                            <li>
                                <NavLink to="/cards/users" activeClassName={styles.is_active}>{t("CardsPagesNames.Users")}</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
                <div>
                    <Switch>
                        <PrivateRoute exact path="/cards/cars" access={AccessLevel.Read} moduleName={AppModules.CarCards} component={CardList} cardsType={cardTypes.AVTO} />
                        <PrivateRoute exact path="/cards/users" access={AccessLevel.Read} moduleName={AppModules.UserCards} component={UserCardList} cardsType={cardTypes.USER} />
                        <PrivateRoute exact path="/cards/cars/addCard" access={AccessLevel.Write} moduleName={AppModules.Cards} component={EditCard}/>
                        <PrivateRoute exact path="/cards/cars/editCard/:id" access={AccessLevel.Write} moduleName={AppModules.Cards} component={EditCard}/>
                        <PrivateRoute exact path="/cards/users/addCard" access={AccessLevel.Write} moduleName={AppModules.Cards} component={EditUserCard}/>
                        <PrivateRoute exact path="/cards/users/editCard/:id" access={AccessLevel.Write} moduleName={AppModules.Cards} component={EditUserCard}/>
                        <Redirect from="/cards" to="/cards/cars" />
                    </Switch>
                </div>
            </div>
    )
}

export default CardsPage;